import {checkVAT as checkVATLib, slovenia as slovenia} from 'jsvat';

let checkRequiredText = [
    v => !!v || 'Polje je obvezno.'
];


let checkRequiredCheckbox = [
    v => !!v || 'Za nadaljevanje je potrebna potrditev.'
];

let checkEmail = [
    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) || 'Vpisani email naslov ni pravilen.',
];

let checkEmailAll = function (email) {
    for (const rule of checkEmail) {
        let result = rule(email);
        if (result !== true) {
            return result;
        }
    }
    return true;
}

let checkCardNumber = [
    v => v && v.length > 0 || 'Polje je obvezno.',
    //v => v && v.length == 13 || 'Številka kartice ni pravilna'
];

let checkCardNumberAll = function (card) {
    for (const rule of checkCardNumber) {
        let result = rule(card);
        if (result !== true) {
            return result;
        }
    }
    return true;
}


let checkNameLastname = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkStreetName = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkHouseNumber = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkZIPNumber = [
    v => v && v.length > 3 || 'Polje je obvezno.',
    v => v && v.length > 3 && isNaN(v) == false || 'Napačna številka.',
];

let checkCity = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkCountry = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkGender = [
    v => {
        return v && v.toString().length > 0 || 'Polje je obvezno.'
    }
];

let checkDateOfBirth = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkDateOfBirthClub = [
    v => {
        return v && v.length > 0 || 'Polje je obvezno.'
    }
];

let checkPhoneNumber = [
    v => {
        if (v && v.length > 0) {
            if (isNaN(v) || v.length <= 8) {
                return 'Neveljavna telefonska številka.'
            }
            return true;
        }
        return true;
    }
];

let checkPhoneNumberRequired = [
    v => {
        if (v && v.length > 8) {
            if (isNaN(v)) {
                return 'Neveljavna telefonska številka.'
            }
            return true;
        }
        return 'Polje je obvezno';
    }
];

let checkPhoneNumberLand = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkEducation = [
    //v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkFamilyMember = [
    //v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkPersonStatus = [
    //v => v && v.length > 0 || 'Polje je obvezno.'
];

let newPasswordRules = [
    v => v && v.length > 7 || 'Minimalno 8 znakov.',
    v => {
        let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
        if (!strongPassword.test(v)) {
            return 'Prešibko geslo. Mora vsebovati male in velike črke, številke ter biti minimalno dolžine 8.';
        }
        return true;
    }
];

let checkShortConfirmationCode = [
    v => v && v.length > 5 || 'Vpišite pravilno kodo.'
];


let newPasswordCheckAgain = function (value, value_again) {
    if (value) {
        return value == value_again || 'Gesli se ne ujemata.';
    } else {
        return 'Potrdi geslo s ponovnim vnosom.';
    }
};

let checkTusTeamCard = [
    v => {
        if (v && v.length > 0) {
            if (isNaN(v)) {
                return 'Neveljavna Tuš team kartica.'
            }
            if (v.length != 13) {
                return 'Neveljavna Tuš team kartica.'
            }
            return true;
        }
        return 'Polje je obvezno';
    }
];

let checkVAT = [
    v => {
        let nV = 'SI' + v;
        if (!checkVATLib(nV, [slovenia]).isValid) {
            return 'Vpišite pravilno davčno številko.';
        }
        return true;
    }
];

let checkResidence = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkMaritalStatus = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkAmount = function(min, max) {
    return [
        v => {
            if (v != null && v.replace) {
                v = v.replace(/ /g, '+')
            }
            if (isNaN(v) || v.length == 0) {
                return 'Vnesite pravilni znesek.'
            }
            let value = parseInt(v);
            if (min != undefined && min != null) {
                if (value < min) {
                    return 'Dovoljene so vrednosti nad ' + min + '.';
                }
            }
            if (max != undefined && max != null) {
                if (value >= max) {
                    return  'Dovoljene so vrednosti pod ' + max + '.';
                }
            }
            return true;
        }
    ]
};

let checkEmployment = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

let checkDate = [
    v => v && v.length > 0 || 'Polje je obvezno.'
];

export default {
    checkRequiredText,
    checkRequiredCheckbox,
    checkEmail,
    checkEmailAll,
    checkCardNumber,
    checkCardNumberAll,
    checkNameLastname,
    checkStreetName,
    checkHouseNumber,
    checkZIPNumber,
    checkCity,
    checkCountry,
    checkResidence,
    checkMaritalStatus,
    checkDateOfBirth,
    checkDateOfBirthClub,
    checkPhoneNumber,
    checkPhoneNumberRequired,
    checkPhoneNumberLand,
    checkEducation,
    checkFamilyMember,
    checkPersonStatus,
    newPasswordRules,
    newPasswordCheckAgain,
    checkGender,
    checkTusTeamCard,
    checkShortConfirmationCode,
    checkVAT,
    checkAmount,
    checkEmployment,
    checkDate,
}
